import React from 'react';
import LabelWithInfo from 'modules/shared/components/label-with-info';
import t from 'utils/translate';
import { selectCompanySettings, selectDataLoaded } from 'modules/settings/stores/company-settings-slice-handler';
import { selectSettingsJson, updateJsonSetting } from 'modules/settings/stores/user-settings-slice-handler';
import { useSelector } from 'react-redux';
import { MY_BUSINESS_OPTIONS } from 'constants/user-settings';
import SelectInput from 'modules/shared/components/select-input';
import { MenuItem } from '@mui/material';
import ActiveInactiveSelector from './active-inactive-selector';
import LabelWithCheckbox from 'modules/shared/components/label-with-checkbox';

function SectionMyBusiness() {
    const dataLoaded = useSelector(selectDataLoaded);
    /**
     * @type {CompanySettings}
     */
    const companySettings = useSelector(selectCompanySettings);
    /**
     * @type {UserSettingsJson}
     */
    const settingsJson = useSelector(selectSettingsJson);

    /**
     * @param {string} field
     * @param {SyntheticBaseEvent} e
     */
    const handleChangeMyBusinessConfirmationWindowDisplay = (field, e) => {
        let newOptions = [...settingsJson.myBusinessConfirmationWindowDisplay];

        if (e.target.checked) {
            newOptions.push(field);
        } else {
            newOptions = newOptions.filter((option) => option !== field);
        }

        updateJsonSetting(
            'myBusinessConfirmationWindowDisplay',
            newOptions,
            t('settings_confirmation_window_display'),
            t('settings_confirmation_window_display_success'),
        );
    };

    const confirmationWindowDisplayLabels = {
        TAKE_LEAD: t('settings_my_business_take_lead_title'),
        UNTAKE_LEAD: t('settings_my_business_untake_lead_title'),
        COMPLETE_PROCESS: t('settings_my_business_complete_process_title'),
        CANCEL_PROCESS: t('settings_my_business_cancel_process_title'),
        CANCEL_REPEAT_PROCESS: t('settings_my_business_cancel_repeat_process_title'),
    };

    if (!dataLoaded || !companySettings.AllowMyBusiness) {
        return;
    }

    return (
        <div className="settings-section" data-test-id="my-business-section">
            <div className="settings-section-title">
                <LabelWithInfo text={t('settings_default_page_mybusiness')} />
                <div className="strike" />
            </div>
            <div className={'section-content'}>
                <div className="section-row">
                    <LabelWithInfo
                        text={t('settings_mybusiness_default_tab_label')}
                        info={t('settings_mybusiness_default_tab_info')}
                        tooltipPlacement="right"
                    />
                    <SelectInput
                        className="info-field-dropdown"
                        value={settingsJson.defaultMyBusinessTab}
                        data-test-id="default-tab"
                        handleChange={(e) => {
                            updateJsonSetting(
                                'defaultMyBusinessTab',
                                e.target.value,
                                t('settings_default_page_mybusiness'),
                                t('js_all_settings_default_mybusiness_tab_successfully'),
                            );
                        }}
                    >
                        <MenuItem value={MY_BUSINESS_OPTIONS.TABS.ACTIVITY}>
                            {t('settings_mybusiness_default_tab_activity')}
                        </MenuItem>
                        <MenuItem value={MY_BUSINESS_OPTIONS.TABS.START}>
                            {t('settings_mybusiness_default_tab_processes')}
                        </MenuItem>
                    </SelectInput>
                </div>

                <div className="section-row">
                    <LabelWithInfo
                        text={t('settings_business_autosave_title')}
                        info={t('js_all_settings_mybusiness_autosave_tooltip')}
                        tooltipPlacement="right"
                    />
                    <ActiveInactiveSelector
                        data-test-id="process-auto-saving"
                        initialValue={settingsJson.myBusinessProcessAutosaving}
                        onChange={(v) => {
                            updateJsonSetting(
                                'myBusinessProcessAutosaving',
                                v,
                                t('settings_default_page_mybusiness'),
                                t('js_all_process_autosaving_changed_successfully'),
                            );
                        }}
                    ></ActiveInactiveSelector>
                </div>

                <div className="section-row">
                    <LabelWithInfo
                        text={t('settings_confirmation_window_display')}
                        info={t('settings_myb_confirmation_window_display_info')}
                    />
                    <SelectInput
                        className="info-field-dropdown"
                        value={[-1]}
                        data-test-id="myb-confirmation-window-display"
                        multiple
                    >
                        <MenuItem value={-1}>{t('settings_select_option')}</MenuItem>
                        {Object.keys(MY_BUSINESS_OPTIONS.CONFIRMATION_WINDOW_DISPLAY).map((option) => (
                            <MenuItem value={MY_BUSINESS_OPTIONS.CONFIRMATION_WINDOW_DISPLAY[option]} key={option}>
                                <LabelWithCheckbox
                                    labelContent={confirmationWindowDisplayLabels[option]}
                                    checked={settingsJson.myBusinessConfirmationWindowDisplay.includes(
                                        MY_BUSINESS_OPTIONS.CONFIRMATION_WINDOW_DISPLAY[option],
                                    )}
                                    onChange={(e) => {
                                        handleChangeMyBusinessConfirmationWindowDisplay(
                                            MY_BUSINESS_OPTIONS.CONFIRMATION_WINDOW_DISPLAY[option],
                                            e,
                                        );
                                    }}
                                />
                            </MenuItem>
                        ))}
                    </SelectInput>
                </div>
            </div>
        </div>
    );
}
export default SectionMyBusiness;
